import LoginContainer from '@components/Login/containers/LoginContainer';
import React from 'react';

const LoginNavigation = () => {
  return <LoginContainer />;
};

export default LoginNavigation;
